import type { EntityValidationRules } from "../services/validationService";
import type FuelType from "./fuelType";

export default class ChargePrice {
  constructor(fuelType?: FuelType) {
    if (fuelType) {
      this.fuelType = fuelType;
    }
  }

  fuelType: FuelType;
  price: number;
}

export const ChargePriceValidationRules: EntityValidationRules<ChargePrice> = {
  fuelType: {
    required: true,
  },
  price: {
    required: true,
    range: {
      min: 1,
      max: 100000000,
    },
  },
};
